// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__1eTQy","normal":"Index_normal__2yssX","normalH5":"Index_normalH5__1gRKf","animationFade":"Index_animationFade__2VPd4"};